module.exports = __webpack_public_path__ + "img/portrait-099.1d67f9a6.jpg";